import { FSK_SP_BANNER_SECTIONS } from '../specialProjects/fskSpecialProject';

export const FSK_BANNER_SECTIONS = FSK_SP_BANNER_SECTIONS;
